import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { FILTERS_QUERY_PARAM } from '../../../../../../../brunswick/constants'
import { collectionHref } from '../../../../../../../lib/routing'

export function useGenerateFilterSelectionPath() {
  const {
    query: { handle },
  } = useRouter()

  const generateFilterSelectionPath = useCallback(
    (filterName: string, value: string): string => {
      if (!handle) return ''
      return collectionHref(handle as string, {
        [FILTERS_QUERY_PARAM]: JSON.stringify({
          [filterName]: [value],
        }),
      })
    },
    [handle]
  )

  return generateFilterSelectionPath
}
